

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface CustomerParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Customer {
  //  customerId: string;
    name: string;
   customerCode: string;
    door: string;
    street: string;
    landmark: string;
    city: string;
    districtId: string;
    pincode: string;
    stateId: string;
    countryId: string;
    mobile: string;
    email: string;
    creditLimit: string;
    tenantId?: string;
    branchId?: string;
    type?:string;
  
    parameters?: CustomerParameter[];
    links?: any;
    openingBalance?:string;
    openingBalanceEntryDate?:string;
    expenseId?:string;
    ledgerName?:string;
}

export abstract class CustomerData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Customer[]>;
  abstract create(url: string,data: Customer): Observable<any>;
  abstract update(url: string,data: Customer): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
